import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {resetPremiumUpsellPanel} from '@Components/panels/premium-upsell-panel/premium-upsell-panel-reducer';
import type {PremiumOnlyFeatureDialogOptions} from '@Libraries/upsell-dialog.library';
import type {RootState} from '@/store';

export interface PremiumUpsellModalOptions extends PremiumOnlyFeatureDialogOptions {
  /** Overrides the feature's default upgrade attribution source, e.g. to tell apart the places one dialog opens from. */
  upsellDialogName?: string;
}

export const openPremiumUpsellModal = (featureName: string, {onDialogLoaded, shouldOpenInNewTab = false, entryPoint, upsellDialogName}: PremiumUpsellModalOptions): void => {
  // Reset before the panel mounts so a prior failure/other-feature's state can't leak into this open
  // (stale hasFailed would self-close the modal; stale data would flash the previous feature's copy).
  window.PMW.redux.store.dispatch(resetPremiumUpsellPanel());
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PREMIUM_UPSELL_MODAL,
      panelProps: {
        modalId: MODALS_IDS.PREMIUM_UPSELL_MODAL,
        featureName,
        shouldOpenInNewTab,
        entryPoint,
        upsellDialogName: upsellDialogName ?? null,
      },
    })
  );

  if (typeof onDialogLoaded === 'function') {
    callWhenPremiumUpsellDialogSettles(onDialogLoaded);
  }
};

/**
 * Calls back once the dialog shows its content, its data fetch fails, or the modal closes (user dismiss or a failed chunk import).
 */
const callWhenPremiumUpsellDialogSettles = (onDialogSettled: () => void): void => {
  const {store} = window.PMW.redux;
  const unsubscribe = store.subscribe((): void => {
    if (!hasPremiumUpsellDialogSettled(store.getState())) {
      return;
    }
    unsubscribe();
    onDialogSettled();
  });
};

const hasPremiumUpsellDialogSettled = (state: RootState): boolean => {
  const {data, hasFailed} = state.premiumUpsellPanel;
  return data !== null || hasFailed || !state.modals.modalsHashmap[MODALS_IDS.PREMIUM_UPSELL_MODAL]?.isOpen;
};
